import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import {
  HasDeleteAccess,
  IsSuperUser,
} from "../../../../../../../_metronic/_helpers/AccessControlHelpers";
import { INVOICE_MODEL } from "../../../../../../../_metronic/_helpers/AppModels";
import { CellContentType, RowType, UserType } from "./types";

export function ActionsColumnFormatter(
  cellContent: CellContentType | undefined,
  row: RowType,
  rowIndex: number,
  {
    user,
    deleteInvoiceButtonClick,
  }: { user: UserType; deleteInvoiceButtonClick: (id: string) => void }
) {
  return (
    <>
      {(HasDeleteAccess(user, INVOICE_MODEL) || IsSuperUser(user)) && (
        <a
          onClick={() => deleteInvoiceButtonClick(row.id)}
          title="حذف فاکتور"
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            {/* @ts-ignore */}
            <SVG
              title={"حذف فاکتور"}
              src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
            />
          </span>
        </a>
      )}
    </>
  );
}
